import { Episode } from "@/types/Episode";
import fetcher_v2 from "../fetcher_v2";
import { QueryOut } from "@/containers/QueryBuilderNew/requestUtils";
import { URLS } from "../urls";
import { ComponentErrors } from "@/types/ComponentErrors";

type PreviewMeta = {
  estimated_mentions: number;
  total_matches: number;
  page_token: number | null;
};

type PreviewResponse = {
  meta: PreviewMeta;
  results: Episode[];
};

type PreviewBody = {
  start_date: string | null;
  end_date: string | null;
  queries: QueryOut[];
  industry: string | null;
};

export const previewSearch = async (data: PreviewBody) => {
  return fetcher_v2<PreviewResponse, PreviewBody, ComponentErrors>(
    URLS.API_PREVIEW_RESULTS,
    {
      method: "POST",
      body: data,
    }
  );
};
